<template>
  <h1>Features</h1>
</template>

<script>
export default {
  name: "HomeFeatures"
}
</script>

<style scoped>

</style>